import React from "react";
import { Button } from "@mui/material";
import DCCostFlowPage from "./DCCostFlowPage";
import pageClasses from "./DCCostFlow.module.css";

const DCCostEstimation = () => (
  <DCCostFlowPage
    title="DC Cost estimation"
    description="Estimate DC costs for inbound loads or SKU batches before committing changes."
  >
    <p className={pageClasses.placeholder}>
      This view will run a dry-run estimation and summarize freight, handling, and tariff impacts.
      Hook up the data pipeline or upload flow here.
    </p>
    <div className={pageClasses.actions}>
      <Button variant="contained" size="small" disabled>
        Start estimation
      </Button>
      <Button variant="outlined" size="small" disabled>
        Upload file
      </Button>
    </div>
  </DCCostFlowPage>
);

export default DCCostEstimation;
